var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    role: "presentation",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.5V17h12.5V4.5H7Zm11 11H8.5V6H18v9.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.5H4V20h12.5v-1.5h-11v-11Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.c82f7db298b8d50b7e187fd583d7d463.svg";
export { ForwardRef as ReactComponent };